import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
import { useTheme } from '@mui/styles';

export const AttentionCard = (props) => {
  const theme = useTheme()

  return (
    <Zoom in={true} style={{ transitionDelay: '500ms'}}>
      <Card sx={{
        border: '1px solid',
        borderColor: theme.palette.primary.main,
        borderRadius: 5,
        display: "flex",
        flexDirection: "column",
        paddingX: 2,
        boxShadow: "none",
        alignItems: "left",
        justifyContent: "left"
      }}>
        <CardContent sx={{mt:0, pb:0}}>
          <Typography gutterBottom variant="h5" component="h2" color="text.primary">
            {props.Title}
          </Typography>
          <Typography variant="body2" component="p" color="text.secondary">
            {props.Text}
          </Typography>
        </CardContent>
      </Card>
    </Zoom>
  )
}

export default AttentionCard;
